import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { useLoadNoSuggestionsRecommendations } from '../../../hooks/useLoadNoSuggestionsRecommendations';
import { NoSuggestionsSkeleton } from '../Skeletons/NoSuggestionsSkeleton';
import { PopularQueries } from '../Suggestions/PopularQueries';
import { SpecialOffersSuggestions } from '../Suggestions/SpecialOffersSuggestions';
import {
    NoSuggestionsRecommendationsWrapper,
    NoSuggestionsWrapper,
    ProductSuggestionsWrapper,
} from './NoSuggestions.styles';

type Props = {
    isNavBar?: boolean;
};

export const NoSuggestionsRecommendations: FC<Props> = ({ isNavBar }) => {
    const { t } = useTranslations();
    const { isLoading, error, suggestions, products, services } = useLoadNoSuggestionsRecommendations();

    if (isLoading) {
        return (
            <NoSuggestionsWrapper aria-live="polite" aria-busy="true">
                <NoSuggestionsSkeleton isNavBar={isNavBar} />
            </NoSuggestionsWrapper>
        );
    }

    if (error) {
        return null;
    }

    return (
        <NoSuggestionsRecommendationsWrapper $isNavBar={isNavBar} aria-live="polite" aria-busy="false">
            <PopularQueries suggestions={suggestions || []} />
            {(!!products?.items.length || !!services?.items.length) && (
                <ProductSuggestionsWrapper>
                    <SpecialOffersSuggestions
                        title={t['search.suggestions.products_recommended.title']}
                        products={products?.items || []}
                        services={services?.items || []}
                    />
                </ProductSuggestionsWrapper>
            )}
        </NoSuggestionsRecommendationsWrapper>
    );
};
